import React, { createContext } from 'react';

const CartContext = createContext({});

export { CartContext };
